import Echo from "laravel-echo";
import Pusher from "pusher-js";

import { useAuthStore } from "@/stores/auth";
let instance = null;

/**
 * Returns an instance of the Echo class for real-time communication with the server.
 * The instance is cached and returned if it already exists, otherwise a new instance is created.
 *
 * @return {Echo} An instance of the Echo class.
 */
export const socket = () => {
  const authStore = useAuthStore();
  if (instance) {
    return instance;
  }

  instance = new Echo({
    broadcaster: "pusher",
    key: import.meta.env.VITE_APP_PUSHER_APP_KEY,
    wsHost: import.meta.env.VITE_APP_PUSHER_HOST,
    wsPort: import.meta.env.VITE_APP_PUSHER_PORT,
    wssPort: import.meta.env.VITE_APP_PUSHER_PORT,
    authEndpoint: import.meta.env.VITE_APP_PUSHER_AUTH_URL,
    auth: {
      headers: {
        Authorization: "Bearer " + authStore.getToken(),
      },
    },
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
  });

  return instance;
};

export default {
  install: () => {
    window.Pusher = Pusher;
  },
};
